import { render, staticRenderFns } from "./ZoneAdd.vue?vue&type=template&id=6d040586&scoped=true&"
import script from "./ZoneAdd.vue?vue&type=script&lang=ts&"
export * from "./ZoneAdd.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d040586",
  null
  
)

export default component.exports